import { getCurrentAuth } from "@/hooks/useAxiosPrivate";

/**
 * Shared auth helpers for the v2 data layer. Both the header (layout/api.ts)
 * and the Notifications page (pages/Notifications/api.ts) build Bearer headers
 * and per-user cache keys the same way; keeping one copy here avoids the two
 * silently diverging.
 */

/** Bearer header when a session exists; empty object keeps public calls anonymous. */
export function authHeaders(): Record<string, string> {
  const token = getCurrentAuth()?.AccessToken;
  return token ? { Authorization: `bearer ${token}` } : {};
}

/** Current user ID for cache isolation; null when logged out. */
export function currentUserId(): string | null {
  const userId = getCurrentAuth()?.UserID;
  return userId != null && userId !== "" ? String(userId) : null;
}
